module.exports = __webpack_public_path__ + "img/0.f0dfdd91.png";